import{css as e}from"@mui/material/styles";import o from"styled-components";const t={none:"",wave:e`
    position: absolute;
    top: -50%;
    left: 0;
    z-index: 0;
    width: 65%;
    height: 200%;
    background: linear-gradient(
      90deg,
      rgb(0 43 81 / 100%) 0%,
      rgb(7 57 99 / 100%) 24%,
      rgb(23 94 147 / 85.6%) 75%,
      rgb(38 126 188 / 51%) 100%
    );
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
  `,gradient:e`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      rgb(0 43 81 / 100%) 0%,
      rgb(7 57 99 / 100%) 22%,
      rgb(23 94 147 / 100%) 66%,
      rgb(38 126 188 / 100%) 100%
    );
  `},r=o("div")`
  position: relative;
  padding: 0;
  overflow: hidden;
  color: ${({theme:e,background:o})=>o?.desktop||"none"!==o.layer?e.palette.common.white:e.palette.common.black};
  background-image: url('${({background:e})=>e?e.desktop?.url:"unset"}');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  .MuiContainer-root {
    position: relative;
    z-index: 1;
  }

  ::before {
    content: '';
    ${({theme:e})=>e.breakpoints.up("md")} {
      ${({background:e})=>"wave"===e.layer&&!e?.desktop&&t.gradient}
    }

    ${({theme:e})=>e.breakpoints.down("md")} {
      ${({background:e})=>"wave"===e.layer&&!e?.desktop&&!e?.mobile&&t.gradient}
    }
  }

  ::after {
    content: '';
    ${({background:e})=>t[e.layer]};
    opacity: ${({background:e})=>"gradient"!==e.layer||e?.desktop?.6:1};
    ${({theme:e})=>e.breakpoints.down("md")} {
      opacity: ${({background:e})=>"gradient"!==e.layer||e?.desktop||e?.mobile?.6:1};
    }
  }

  ${({theme:e})=>e.breakpoints.up("md")} {
    display: flex;
    align-items: center;
    min-height: 465px;
  }

  ${({theme:e})=>e.breakpoints.down("md")} {
    color: ${({theme:e,background:o})=>o?.mobile||o?.desktop||"none"!==o.layer?e.palette.common.white:e.palette.common.black};
    background-image: url('${({background:e})=>e?.mobile?.url||e?.desktop?.url||"unset"}');
  }
`;export{r as PageHeroDiv};
//# sourceMappingURL=styles.js.map
